import { FunctionComponent, useState } from "react";
import { useTranslation } from "next-i18next/pages";
import styles from "../../styles/home/FAQ.module.css";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {}

const FAQ: FunctionComponent<FAQProps> = () => {
  const { t } = useTranslation("common");
  const faqs: FAQItem[] = t("faq.all", { returnObjects: true }) as FAQItem[];
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className={styles.faqContainer}>
      <h2 className={styles.title}>{t("faq.title")}</h2>
      <div className={styles.faqList}>
        {faqs.map((faq: FAQItem, index: number) => (
          <div
            key={index}
            className={`${styles.faqItem} ${openIndex === index ? styles.open : ""}`}
          >
            <button
              className={styles.faqQuestion}
              onClick={() => toggleFAQ(index)}
              aria-expanded={openIndex === index}
              type="button"
            >
              <span>{faq.question}</span>
              <span className={styles.faqIcon}>{openIndex === index ? "−" : "+"}</span>
            </button>
            <div className={styles.faqAnswer}>
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
